export const cibBing = ["32 32","<path d='M4.807 0l6.391 2.25v22.495l9.005-5.193-4.411-2.073-2.786-6.932 14.188 4.984v7.245l-15.99 9.224-6.396-3.563z'/>"]